import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusSquareFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-plus-square",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 18,
			height: 18,
			rx: 2,
			ry: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 8,
			x2: 12,
			y2: 16,
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			y1: 12,
			x2: 16,
			y2: 12,
			stroke: "white"
		})
	]
});
export default SvgPlusSquareFill;
